export default (dc, { defaultModel, defaultView, ...config }) => {
  const type = 'slider-dot'
  const attrKey = config.attrSliderDot
  const classKey = config.classSliderDot

  dc.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider Dot',
        draggable: false,
        droppable: false,
        copyable: false,
        removable: false,
        'class-dot-active': config.classDotActive,
        ...config.sliderDotProps
      },

      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView
  })
}
